import {
	ChangeDetectionStrategy,
	Component,
	ComponentFactoryResolver,
	Inject,
	Input,
	Type,
	ViewChild,
	ViewContainerRef
} from '@angular/core';
import { AbstractWrapper } from '../abstract-wrapper.class';
import { ILuSelectCustomItem, LuSelectType } from '../lu-select.models';
import { LuSelectCustomItem } from './lu-select-custom-item';
import { LuSelectItemBasicComponent } from './lu-select-item-basic/lu-select-item-basic.component';
import { LuSelectItemImageComponent } from './lu-select-item-image/lu-select-item-image.component';

@Component({
	// eslint-disable-next-line @angular-eslint/component-selector
	selector: 'lu-select-item-wrapper',
	template: `<ng-template #itemComponent></ng-template>`,
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class LuSelectItemWrapperComponent extends AbstractWrapper {
	@ViewChild('itemComponent', { read: ViewContainerRef, static: true }) containerRef: ViewContainerRef;
	@Input() options: any;
	@Input() selectedItem: boolean;
	@Input() set data(itemValue: any) {
		this.containerRef.clear();
		let type: Type<any>;
		switch (this.options.type) {
			case LuSelectType.BASIC: {
				type = LuSelectItemBasicComponent;
				const item = this.createComponent<LuSelectItemBasicComponent>(this.containerRef, type);
				item.instance.selectedItem = this.selectedItem;
				item.instance.options = this.options;
				item.instance.data = itemValue;
				break;
			}
			case LuSelectType.IMAGE: {
				type = LuSelectItemImageComponent;
				const item = this.createComponent<LuSelectItemImageComponent>(this.containerRef, type);
				item.instance.selectedItem = this.selectedItem;
				item.instance.options = this.options;
				item.instance.data = itemValue;
				break;
			}
			case LuSelectType.CUSTOM: {
				type = this.options.itemComponent;
				const item = this.createComponent<LuSelectCustomItem<ILuSelectCustomItem>>(this.containerRef, type);
				this.options.interface.selectedItem = this.selectedItem;
				item.instance.data = itemValue;
				item.instance.interface = this.options.interface;
				break;
			}
			default: {
				break;
			}
		}
	}

	constructor(@Inject(ComponentFactoryResolver) protected componentFactoryResolver: ComponentFactoryResolver) {
		super(componentFactoryResolver);
	}
}
